import { render, staticRenderFns } from "./newVarios.vue?vue&type=template&id=27a5a74d"
import script from "./newVarios.vue?vue&type=script&lang=js"
export * from "./newVarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports